<template>
    <div>
      
      <TotalAndAssignedCards />

      <v-row>
        <v-col cols="12" md="8">
          <DrawingDrawingCategoryStackedBarChart
            @chartClick="handleChartClick"
            :filterContext="filterContext"
            @updateFilter="(chartId, ids) => filterContext.updateFilter(chartId, ids)"
          />
        </v-col>
        <v-col cols="12" md="4">
          <CategoryStackedBarChart
            @chartClick="handleChartClick"
            :filterContext="filterContext"
            @updateFilter="(chartId, ids) => filterContext.updateFilter(chartId, ids)"
          />
        </v-col>
      </v-row>
  
      <!-- Items Data Table -->
      <v-row>
        <v-col cols="12" md="12">
          <ItemsGrid
            @chartClick="handleChartClick"
            :filterContext="filterContext"
            @updateFilter="(chartId, ids) => filterContext.updateFilter(chartId, ids)"
          />
        </v-col>
      </v-row>
    </div>
  </template>
  
  <script setup>
  import { computed, onMounted } from 'vue';
  import { useStore } from 'vuex';
  import ItemsGrid from './grids/ItemsGrid.vue';
  import TotalAndAssignedCards from './card-arrays/TotalAndAssignedCards.vue';
  import DrawingDrawingCategoryStackedBarChart from './charts/DrawingDrawingCategoryStackedBarChart.vue';
  import CategoryStackedBarChart from './charts/CategoryStackedBarChart.vue';
  
  const store = useStore();
  const filterContext = computed(() => store.state.filterItemsContext);

  onMounted(async () => {
    await store.commit('resetFilters');
  });

    
</script>
  
  <style scoped>
  .v-chip {
    padding: 0 4px !important;
  }
  .v-data-table .v-icon {
    opacity: 0.6;
  }
  </style>